var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",class:{active: _vm.active},style:(_vm.style)},[_c('img',{staticClass:"image",attrs:{"refs":"img","src":_vm.src,"srcset":_vm.srcset,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }